import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from './url';

const baseQuery = fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
        headers.set('accept', '*/*');

        if (!headers.has('x-portal')) {
            headers.set('x-portal', 'admin');
        }

        headers.set('app', 'anstmasr2588');

        // Auth token from state only
        const token = (getState() as any).auth.token;

        if (token) {
            headers.set('authorization', `Bearer ${token}`);
        }

        return headers;
    },
});

const baseQueryWithInterceptor: typeof baseQuery = async (args, api, extraOptions) => {
    const result = await baseQuery(args, api, extraOptions);
    return result;
};

export const api = createApi({
    reducerPath: 'api',
    baseQuery: baseQueryWithInterceptor,
    tagTypes: [
        'User',
        'Categories',
        'Brands',
        'Models',
        'VehicleTypes',
        'FuelTypes',
        'EnginePower',
        'Transmission',
        'DriveTypes',
        'EmissionClass',
        'EnvironmentalBadge',
        'DamageType',
        'Axles',
        'Features',
        'Colors',
        'Conditions',
        'Vehicles',
        'SpareParts',
        'ManageUsers',
        'Accessories',
        'CMS',
        'Variants',
        'StripePlans',
        'Permissions',
        'SubAdmin',
        'Revenue',
        'Showrooms',
        'Notifications',
        'Blogs',
    ],
    endpoints: () => ({}),
});